import currency from "currency.js";
import { fetchActionsUtil, formatForQty } from "../../utils/helpers";
import {
  AllInvoicesIcon,
  BookIcon,
  BucketIcon,
  ClockIcon,
  CustomerFeedbackIcon,
  InvoiceDashboardIcon,
  InvoiceOverDue,
  InvoicePaidIcon,
  InvoiceUpcomingIcon,
  InvoiceUpnaidIcon,
  LineChartIcon,
  NewUserIcon,
  OverdueInvoiceStatsIcon,
  PaidInvoiceStatIcon,
  PurchasesIcon,
  ReceivePaymentIcon,
  SideBarToggleIcon,
  UnpaidInvoiceStatsIcon,
  UpcomingInvoiceStatsIcon,
  UserIcon,
} from "../Icons";
import { Link, Outlet } from "react-router-dom";
import "../../assets/scss/customInvoiceWrapper.scss";
import InvoiceAnalysisChart from "./InvoiceAnalysisChart";
import InvoiceAnalysisPieChart from "./InvoiceAnalysisPieChart";
import { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { useQuery } from "react-query";
import { useAuth } from "../../hooks/useAuth";
import { useQueryParams } from "../../utils/hooks";

import queryString from "query-string";

const items = [
  { name: "Dashboard", icon: <InvoiceDashboardIcon />, link: "" },
  {
    name: "Customer Details",
    icon: <UserIcon />,
    link: "/reports/customer-detail",
  },
  {
    name: "All Invoices",
    icon: <AllInvoicesIcon className=" text-primary" />,
    link: "/invoices/all",
  },
  {
    name: "Paid",
    icon: <InvoicePaidIcon />,
    link: "/invoices/paid-invoices",
  },
  {
    name: "Unpaid",
    icon: <InvoiceUpnaidIcon />,
    link: "/invoices/unpaid-invoices",
  },
  {
    name: "Upcoming",
    icon: <InvoiceUpcomingIcon />,
    link: "/invoices/upcoming-invoices",
  },
  {
    name: "Overdue",
    icon: <InvoiceOverDue />,
    link: "/invoices/overdue-invoices",
  },
  {
    name: "Receive Payment",
    icon: <ReceivePaymentIcon className=" text-primary" />,
    link: "/post-payments",
  },
  {
    name: "Purchases",
    icon: <PurchasesIcon className=" text-primary" />,
    link: "/reports/sales-analysis",
  },
  {
    name: "Customer Feedback",
    icon: <CustomerFeedbackIcon className=" text-primary" />,
    link: "/reports/customer-feedback",
  },
  {
    name: "Targets",
    icon: <CustomerFeedbackIcon className=" text-primary" />,
    link: "/reports/customer-target",
  },
  {
    name: "Scheduled Transactions",
    icon: <ClockIcon />,
    link: "/invoices/scheduled-transactions",
  },
  {
    name: "Quotation",
    icon: <BookIcon />,
    link: "/sales-and-invoicing/quotation",
  },
];
export default function CustomerProfileWrapper({
  children,
  isStore = false,
  customerId,
}) {
  const [isOpen, setIsOpen] = useState(true);
  let {
    backendUrl,
    customerBackendUrl,
    token,
    user: authUser,
    customer,
  } = useAuth();

  const initialFilterParams = {
    // Staff_ID: customer?.Staff_ID,
    // customerId: customerId || "",
  };

  const [queryParams, setQueryParams] = useQueryParams({
    page: 1,
    limit: 40,
    ...initialFilterParams,
  });

  useEffect(() => {
    const handleResize = () => {
      if (window?.innerWidth > 768) {
        setIsOpen(true);
      } else {
        setIsOpen(false);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  // useEffect(() => {
  //   setQueryParams({
  //     ...queryParams,

  //     Staff_ID: isStore
  //       ? customer?.Staff_ID
  //       : authUser?.invexVersion === "InvexInvoicing"
  //       ? authUser?.Staff_ID
  //       : "",

  //     customerId: customer?.Cust_ID || customerId,
  //   });
  // }, [customer?.Staff_ID, customer?.Cust_ID, customerId]);

  useEffect(() => {
    const handleResize = () => {
      if (window?.innerWidth > 768) {
        setIsOpen(true);
      } else {
        setIsOpen(false);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const { data, refetch, isFetching, isSuccess } = useQuery(
    ["FETCH_INVOICE_STATISTICS_DASHBOARD_NEW", queryParams],
    () =>
      fetchActionsUtil(
        `${
          isStore ? customerBackendUrl : backendUrl
        }/api/invoice/dasboard-layout-stats?&${queryString.stringify(
          queryParams,
        )}`,
        "GET",
      ),
  );

  // I need a use effect to always be checking my window width so I can set a state

  return (
    <>
      <div className="custom-invoice-wrapper  " style={{ minHeight: "90vh" }}>
        <div className={"d-flex"}>
          <div className={isOpen ? "dashboard-menu  " : "dashboard-menu-close"}>
            <div className=" bg-white">
              <ul>
                {items.map((item, index) => {
                  // if (
                  //   authUser?.planType?.toLowerCase() === "free" &&
                  //   ["quotation", "scheduled transactions"].includes(
                  //     item?.name?.toLowerCase()
                  //   )
                  // ) {
                  //   return null;
                  // }
                  return (
                    <Link
                      to={`${item.link}?customerId=${customerId}`}
                      className="btn d-flex    align-items-center gap-1 custom-link"
                      title={item?.name}
                    >
                      <div className="icon">{item.icon}</div>
                      {isOpen && <span className="">{item.name}</span>}
                    </Link>
                  );
                })}
                {/* <button
                  className="  bg-primary"
                  onClick={() => setIsOpen((prev) => !prev)}
                >
                  <SideBarToggleIcon />
                </button> */}
              </ul>
            </div>
          </div>

          <div className="custom-invoice-stats">
            <section className=" custom-stat-items">
              <section className={`custom-stats mb-3   `}>
                <Link to={`/invoices/paid-invoices?customerId=${customerId}`}>
                  <div className="custom-stat  border rounded-4">
                    <div className="icon icon-1">
                      <PaidInvoiceStatIcon />
                    </div>

                    <div className="custom-details">
                      <p>
                        {currency(Number(data?.data?.paid), {
                          symbol: "",
                          precision: 2,
                          format: formatForQty,
                        }).format()}
                      </p>
                      <span>Paid</span>
                    </div>
                  </div>
                </Link>

                <Link
                  to={`/invoices/upcoming-invoices?customerId=${customerId}`}
                >
                  <div className="custom-stat  border rounded-4">
                    <div className="icon bg-light-blue">
                      <UpcomingInvoiceStatsIcon />
                    </div>
                    <div className="custom-details">
                      <p>
                        {currency(Number(data?.data?.upcoming), {
                          symbol: "",
                          precision: 2,
                          format: formatForQty,
                        }).format()}
                      </p>
                      <span>Upcoming</span>
                    </div>
                  </div>
                </Link>

                <Link
                  to={`/invoices/overdue-invoices?customerId=${customerId}`}
                >
                  <div className="custom-stat  border rounded-4">
                    <div className="icon ">
                      <OverdueInvoiceStatsIcon />
                    </div>
                    <div className="custom-details">
                      <p>
                        {currency(Number(data?.data?.overdue), {
                          symbol: "",
                          precision: 2,
                          format: formatForQty,
                        }).format()}
                      </p>
                      <span>Overdue</span>
                    </div>
                  </div>
                </Link>

                <Link to={`/invoices/unpaid-invoices?customerId=${customerId}`}>
                  <div className="custom-stat  border rounded-4">
                    <div className="icon  icon-2">
                      <UnpaidInvoiceStatsIcon />
                    </div>
                    <div className="custom-details">
                      <p>
                        {currency(Number(data?.data?.unpaid), {
                          symbol: "",
                          precision: 2,
                          format: formatForQty,
                        }).format()}
                      </p>
                      <span>Unpaid</span>
                    </div>
                  </div>
                </Link>
              </section>

              {children}
            </section>
          </div>
        </div>

        {/* {Nav && <div className="nav-bar">{Nav}</div>} */}
        <Outlet />
      </div>
    </>
  );
}
